<template>
  <vx-card id="invoice-container">
    <vs-col class="mb-6" v-if="selected.stato && button_bar" vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
      <h3>PREVENTIVO N. {{ getNumero(selected['numero'],selected['data_emissione']) }}</h3>
      <vs-col v-if="selected.stato.ordine < 5" vs-w="2" vs-lg="2" vs-sm="2" vs-xs="2">
        <vs-button class="w-full" @click="open_stato" color="success" type="line" icon-pack="feather" icon="icon-cloud-lightning" align="right">Cambia Stato</vs-button>
      </vs-col>
      <vs-col v-if="selected.stato.ordine < 5" vs-w="2" vs-lg="2" vs-sm="2" vs-xs="2">
        <vs-button class="w-full" @click="inviaDoc" icon-pack="feather" icon="icon-mail" color="primary" type="line" align="right">Invia</vs-button>
      </vs-col>
      <vs-col vs-w="2" vs-lg="2" vs-sm="2" vs-xs="2">
        <vs-button class="w-full" @click="generatePDF" icon-pack="feather" icon="icon-download" color="primary" type="line" align="right">PDF</vs-button>
      </vs-col>
      <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
      <vs-popup :key="Math.random()" class="holamundo text-center" title="Avanza Stato Preventivo" :active.sync="popupStato">
        <p class="mb-3">
          Scegliere lo stato a cui portare il Preventivo
        </p>
        <vs-row class="m-3">
          <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
            <vs-select class="mb-3" v-model="avanza_stato">
              <vs-select-item v-if="selected.stato.ordine < 2" :key="1" value="2" text="Consegnato" />
              <vs-select-item v-if="selected.stato.ordine < 4" :key="2" value="4" text="Accettato" />
              <vs-select-item v-if="selected.stato.ordine < 5" :key="3" value="5" text="Rifiutato" />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button  @click="commitStato()" icon-pack="feather" icon="icon-cloud-lightning" type="line" color="success"> Cambia Stato </vs-button>
        </vs-col>
      </vs-popup>
    </vs-col>
    <vs-divider />
    <!-- INVOICE METADATA -->
    <div class="vx-row leading-loose p-base">
      <div class="vx-col w-1/2 mt-base">
        <img :src="`/preven_logo/`+logo+`.png`" width="300px" alt="logo">
        <!-- <img v-if="logo ? logo : display_logo == 'ISCOM'" src="/preven_logo/ISCOM.png" width="300px" alt="logo">
        <img v-else-if= "logo ? logo : display_logo == 'CEDASCOM' || (selected.azienda && selected.azienda.stato == 'SOCIO')" src="/preven_logo/CEDASCOM.png" width="300px" alt="logo">
        <img v-else src="/preven_logo/CONFCOMMERCIO.png" width="300px" alt="logo"> -->
      </div>
      <div class="vx-col w-1/2 text-right">
        <h1>Preventivo</h1>
        <div class="invoice__invoice-detail mt-6">
            <h6>N.</h6>
            <p>{{ getNumero(selected['numero'],selected['data_emissione']) }}</p>

            <h6 class="mt-4">Data Preventivo</h6>
            <p>{{$tariffe.formatDateNew(selected['data_emissione'])}}</p>
        </div>
      </div>
      <div v-if="selected['azienda']" class="vx-col w-1/2 mt-12">
        <h5>Cliente</h5>
        <div class="invoice__recipient-info my-4">
          <p>{{ selected['azienda'].ragione_sociale }}</p>
          <p>{{ [ [selected['azienda']['indirizzo_tipo_via_dl'], selected['azienda']['indirizzo_dl']].filter(e => e).join(' '),
                selected['azienda']['indirizzo_numero_dl'],
                selected['azienda']['frazione_dl']
                ].filter(e => e).join(', ') }}</p>
          <p>{{ [selected['azienda']['capfrazione_dl'] || selected['azienda']['cap_dl'],
                selected['azienda']['comune_dl'],
                selected['azienda']['provincia_dl']].filter(e => e).join(', ') }}</p>
        </div>
        <div class="invoice__recipient-contact ">
          <p v-if="selected['azienda']['email_dl'] || selected['azienda']['email_dc']" class="flex items-center">
              <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ selected['azienda']['email_dl'] || selected['azienda']['email_dc'] }}</span>
          </p>
          <p v-if="selected['azienda']['telefono_dl'] || selected['azienda']['telefono_dc']" class="flex items-center">
              <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ selected['azienda']['telefono_dl'] || selected['azienda']['telefono_dc'] }}</span>
          </p>
        </div>
      </div>
      <div v-if="selected['contatto']" class="vx-col w-1/2 mt-12">
        <h5>Cliente</h5>
        <div class="invoice__recipient-info my-4">
          <p>{{ [selected['contatto'].nome,selected['contatto'].cognome].join(' ') }}</p>
          <p>{{ selected['contatto']['residenza']}}</p>
          <p>{{ [selected['contatto']['residenza_cap'],
                selected['contatto']['residenza_comune'],
                selected['contatto']['residenza_provincia']
                ].filter(e => e).join(', ') }}</p>
        </div>
        <div class="invoice__recipient-contact ">
          <p class="flex items-center">
              <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ selected['contatto']['email'] }}</span>
          </p>
        </div>
      </div>
      <div v-if="selected && selected['responsabile']" class="vx-col w-1/2 mt-base text-right mt-12">
        <h5>{{ [selected['responsabile'].cognome,selected['responsabile'].nome].join(' ') }}</h5>
        <div class="invoice__company-contact">
          <p v-if="selected['responsabile'].email" class="flex items-center justify-end">
            <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
            <span class="ml-2">{{ selected['responsabile'].email }}</span>
          </p>
          <p v-if="selected['responsabile'].telefono" class="flex items-center justify-end">
            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
            <span class="ml-2">{{ selected['responsabile'].telefono }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- INVOICE CONTENT -->
    <vs-row v-if="selected['voci']" class="p-base white_back">
    <!-- {{['ShowData -> ',showData,' withUser -> ',withUser].join('\n')}} -->
      <!-- INVOICE TASKS TABLE -->
      <vs-table :data="selected['voci']" class="w-full">
        <!-- HEADER -->
        <!-- <template slot="thead">
            <vs-th :key="0">Nome</vs-th>
            <vs-th :key="1">Servizio</vs-th>
            <vs-th :key="2">Quantità</vs-th>
            <vs-th :key="3" v-if="showData">Tariffa</vs-th>
            <vs-th :key="4">Preventivato</vs-th>
            <vs-th :key="5" v-if="showData">Totale</vs-th>
            <vs-th :key="6" v-if="showData">Sconto</vs-th>
            <vs-th :key="7"></vs-th>
        </template> -->

        <template slot="thead">
          <vs-row class="w-full" vs-type="flex" vs-justify="flex">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" :vs-w="withUser ? 2 : 4">
              <vs-th :key="0">Nome</vs-th>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" :vs-w="withUser ? 1 : 3">
              <vs-th :key="1">Servizio</vs-th>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
              <vs-th :key="2">Quantità</vs-th>
            </vs-col>
            <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
              <!-- <vs-th :key="3">{{!showData ? '' : 'Tariffa'}}</vs-th> -->
              <vs-th :key="3">Tariffa</vs-th>
            </vs-col>
            <vs-col v-if="withUser || preventivoAtariffa" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
              <vs-th :key="4">Preventivato</vs-th>
            </vs-col>
            <vs-col v-if="withUser || preventivoAtariffa" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
              <!-- <vs-th :key="5">{{!showData ? '' : 'Totale'}}</vs-th> -->
              <vs-th :key="5">Totale</vs-th>
            </vs-col>
            <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
              <!-- <vs-th :key="6">{{!showData ? '' : 'Sconto'}}</vs-th> -->
              <vs-th :key="6">Sconto</vs-th>
            </vs-col>
          </vs-row>
        </template>
        <!-- DATA -->
        <template slot-scope="{data}">
            <colgroup ref="colgrouptable">
              <col :key="0" :name="`col-0`" />
              <col :key="1" :name="`col-1`" />
              <col :key="2" :name="`col-2`" />
              <col :key="3" :name="`col-3`" />
              <col :key="4" :name="`col-4`" />
              <col :key="5" :name="`col-5`" />
              <col :key="6" :name="`col-6`" />
            </colgroup>
          <vs-tr class="no-pointer" v-for="(tr, index) in selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier != '0' && v.tariffa_applicata.quantifier != 'u') return v})" :key="index">
            <vs-row class="w-full" vs-type="flex" vs-justify="flex">
              <!-- {{tr.tariffa_applicata.weight}} -->
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" :vs-w="withUser ? 2 : 4">
                <vs-td :key="0" :data="tr.tariffa_applicata.nome"><b>{{tr.tariffa_applicata.nome}}</b></vs-td>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" :vs-w="withUser ? 1 : 3">
                <vs-td :key="1" :data="tr.tariffa_applicata.tipo_servizio">{{ tr.tariffa_applicata.tipo_servizio }}</vs-td>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                <vs-td :key="2" :data="tr.quantita">{{ tr.quantita }}</vs-td>
              </vs-col>
              <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <!-- <vs-td v-if="tr.tariffa_applicata.servizio.codice == 'Paghe'" :key="3" :data="tr.preventivato">
                  {{ vue_damn_linter(tr) }}
                </vs-td> -->
                <!-- <vs-td v-if="!showData" :key="3">
                </vs-td> -->
                <vs-td :key="3" :data="tr.preventivato">
                  {{[new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,0,selected['importo_vecchio'])),' €'].join('')}}
                </vs-td>
              </vs-col>
              <vs-col v-if="withUser || preventivoAtariffa" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <!-- <vs-td v-if="tr.tariffa_applicata.servizio.codice == 'Paghe' && withUser" :key="4" :data="tr.preventivato">
                  {{[new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.preventivato),' € (',new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,1,selected['importo_vecchio'])),' €)'].join('')}}
                </vs-td> -->
                <!-- <vs-td v-else-if="!preventivoAtariffa" :key="4">
                </vs-td> -->
                <vs-td :key="4" :data="tr.preventivato">
                  {{
                    [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,1,selected['importo_vecchio'])),' €'].join('')
                  }}
                </vs-td>
              </vs-col>
              <vs-col v-if="withUser || preventivoAtariffa" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <!-- <vs-td v-if="preventivoAtariffa" :key="5" :data="tr.preventivato">{{
                  [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.preventivato),' €'].join('')
                }}</vs-td> -->
                <!-- <vs-td v-if="!showData" :key="5">
                </vs-td> -->
                <vs-td :key="5" :data="tr.preventivato">
                  {{[new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.preventivato),' €'].join('')}}
                </vs-td>
              </vs-col>
              <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <vs-td :key="6" :data="tr.preventivato">{{ [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,1,selected['importo_vecchio']) - $tariffe.calcolaVoce(tr,0,selected['importo_vecchio'])),
                  ' € (',new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaScontoVoce(tr,selected['importo_vecchio'])),'%)'].join('') }}</vs-td>
                <!-- <vs-td v-else-if="!preventivoAtariffa" :key="6">
                </vs-td>
                <vs-td v-else :key="6">
                </vs-td> -->
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="space-around">
            <!-- <template class="expand-tariffa" slot="expand"> -->
              <vs-divider />
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
                <div :key="7" :data="tr.tariffa_applicata.descrizione" class="quill" :id="'quill-'+index"></div>
                <!-- <div :key="7" class="quill" :id="'quill-'+index"></div> -->
              </vs-col>
            <!-- </template>   -->
            </vs-row>
          </vs-tr>
        </template>
      </vs-table>
      <!-- INVOICE SUMMARY TABLE -->
      <vs-table v-if="selected['voci'].length" class="w- 2/3 ml-auto mt-4" :data="[selected['voci'],selected['sconto_percentuale']]">
        <vs-tr v-if="showData">
          <vs-th class="pointer-events-none">SUBTOTALE</vs-th>
          <vs-td>{{ [$tariffe.calcolaPreventivo(selected['voci'],0,selected['importo_vecchio']),'€'].join(' ') }}</vs-td>
        </vs-tr>
        <vs-tr v-if="selected['sconto_percentuale'] != 0 && withUser">
          <vs-th class="pointer-events-none">SCONTO</vs-th>
          <vs-td>{{ [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaPreventivo(selected['voci'],1,selected['importo_vecchio']) - $tariffe.calcolaPreventivo(selected['voci'],0,selected['importo_vecchio'])),
            ' € (',new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected['sconto_percentuale']),'%)'].join('') }}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-th class="pointer-events-none">TOTALE</vs-th>
          <vs-td>{{ [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaPreventivo(selected['voci'],1,$parseCurrency(selected['importo_vecchio']))),'€'].join(' ') }}</vs-td>
          <!-- <vs-td>{{ [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(selected['importo_finale'] ? selected['importo_finale'] : $tariffe.calcolaPreventivo(selected['voci'],1,$parseCurrency(selected['importo_vecchio']))),'€'].join(' ') }}</vs-td> -->
        </vs-tr>
      </vs-table>
      <vs-col v-if="escl_length">
        <h4 class="mt-6 mb-4 bold">Voci escluse dal Totale</h4>
        <!-- EXCLUDED VOCI TABLE -->
        <vs-table :data="selected['voci']" class="w-full">
          <!-- HEADER -->
          <template slot="thead">
            <vs-row class="w-full" vs-type="flex" vs-justify="flex">
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" :vs-w="withUser ? 2 : 4">
                <vs-th :key="0">Nome</vs-th>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" :vs-w="withUser ? 1 : 3">
                <vs-th :key="1">Servizio</vs-th>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                <vs-th :key="2">Quantità</vs-th>
              </vs-col>
              <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <!-- <vs-th :key="3">{{!showData ? '' : 'Tariffa'}}</vs-th> -->
                <vs-th :key="3">Tariffa</vs-th>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <vs-th :key="4">Preventivato</vs-th>
              </vs-col>
              <vs-col v-if="withUser || preventivoAtariffa" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <!-- <vs-th :key="5">{{!showData ? '' : 'Totale'}}</vs-th> -->
                <vs-th :key="5">Totale</vs-th>
              </vs-col>
              <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <!-- <vs-th :key="6">{{!showData ? '' : 'Sconto'}}</vs-th> -->
                <vs-th :key="6">Sconto</vs-th>
              </vs-col>
            </vs-row>
          </template>
          <!-- DATA -->
          <template slot-scope="{data}">
            <colgroup ref="colgrouptable">
              <col :key="0" :name="`col-0`" />
              <col :key="1" :name="`col-1`" />
              <col :key="2" :name="`col-2`" />
              <col :key="3" :name="`col-3`" />
              <col :key="4" :name="`col-4`" />
              <col :key="5" :name="`col-5`" />
              <col :key="6" :name="`col-6`" />
            </colgroup>
            <vs-tr class="no-pointer" v-for="(tr, index) in selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier == '0' || v.tariffa_applicata.quantifier == 'u') return v})" :key="index">
              <vs-row class="w-full" vs-type="flex" vs-justify="left">
                <!-- {{tr.tariffa_applicata.weight}} -->
                <vs-col vs-type="flex" vs-justify="left" vs-align="center" :vs-w="withUser ? 2 : 4">
                  <vs-td :key="0" :data="tr.tariffa_applicata.nome"><b>{{tr.tariffa_applicata.nome}}</b></vs-td>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" :vs-w="withUser ? 1 : 3">
                  <vs-td :key="1" :data="tr.tariffa_applicata.tipo_servizio">{{ tr.tariffa_applicata.tipo_servizio }}</vs-td>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                  <vs-td :key="2" :data="tr.quantita">{{ tr.quantita }}</vs-td>
                </vs-col>
                <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                  <!-- <vs-td v-if="tr.tariffa_applicata.servizio.codice == 'Paghe' && withUser" :key="3" :data="tr.preventivato">
                    {{ vue_damn_linter(tr) }}
                  </vs-td> -->
                  <!-- <vs-td v-if="!showData" :key="3">
                  </vs-td> -->
                  <vs-td :key="3" :data="tr.preventivato">
                    {{
                      [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,0,selected['importo_vecchio'])),' €'].join('')
                    }}
                  </vs-td>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                  <!-- <vs-td v-if="tr.tariffa_applicata.servizio.codice == 'Paghe'" :key="4" :data="tr.preventivato">
                    {{
                      [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.preventivato),' € (',new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,1,selected['importo_vecchio'])),' €)'].join('')
                    }}
                  </vs-td> -->
                  <!-- <vs-td v-else-if="!showData" :key="4">
                  </vs-td> -->
                  <vs-td :key="4" :data="tr.preventivato">
                    {{
                      [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,1,selected['importo_vecchio'])),' €'].join('')
                    }}
                  </vs-td>
                </vs-col>
                <vs-col v-if="withUser || preventivoAtariffa" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                  <!-- <vs-td v-if="preventivoAtariffa" :key="5" :data="tr.preventivato">{{
                    [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.preventivato),
                    ' €'].join('')
                    }}</vs-td> -->
                    <!-- <vs-td v-if="!showData" :key="5">
                    </vs-td> -->
                    <vs-td :key="5" :data="tr.preventivato">
                      {{
                        [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.preventivato),' €'].join('')
                      }}
                    </vs-td>
                </vs-col>
                <vs-col v-if="withUser" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                  <vs-td :key="6" :data="tr.preventivato">{{ [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaVoce(tr,1,selected['importo_vecchio']) - $tariffe.calcolaVoce(tr,0,selected['importo_vecchio'])),
                    ' € (',new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format($tariffe.calcolaScontoVoce(tr,selected['importo_vecchio'])),'%)'].join('') }}
                  </vs-td>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="space-around">
              <!-- <vs-row v-if="tr.tariffa_applicata.descrizione && tr.tariffa_applicata.descrizione != '<p>-</p>'" vs-type="flex" vs-justify="space-around"> -->
              <!-- <vs-row v-if="tr.tariffa_applicata.descrizione" vs-type="flex" vs-justify="space-around"> -->
                <vs-divider />
                <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
                  <vs-td :key="6" :data="tr.tariffa_applicata.descrizione" class="quill" :id="'quill-'+(index+incl_lenght)"></vs-td>
                </vs-col>
              </vs-row>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
    <!-- INVOICE FOOTER -->
    <div v-if="selected['visibilita_note'] && selected['note']" class="invoice__footer text-right p-base">
      <p class="mb-4">Note Cliente: {{selected['note']}}</p>
    </div>
  </vx-card>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      display_logo: "",
      popupStato: false,
      avanza_stato: 0,
    }
  },
  props: {
    selected: Object,
    logo: String,
    stati: {
      type: Array,
      default: function () {
        return []
      }
    },
    button_bar: {
      type: Boolean,
      default: function () {
        return false
      }
    },
  },
  // watch: {
  //   logo (val) {
  //     console.log(val,' :logo');
  //   },
  //   display_logo (val) {
  //     console.log(val,' :display_logo');
  //   },
  // },
  mounted () {
    this.display_logo = this.$tariffe.returnLogoString(this.selected)
    this.show_eachVoceDesc()
    this.sortVoci()
  },
  computed: {
    inlc () {
      return this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier != '0' && v.tariffa_applicata.quantifier != 'u') return v})
    },
    incl_lenght () {
      return this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier != '0' && v.tariffa_applicata.quantifier != 'u') return v}).length
    },
    escl () {
      return this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier == '0' || v.tariffa_applicata.quantifier == 'u') return v})
    },
    escl_length () {
      return this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier == '0' || v.tariffa_applicata.quantifier == 'u') return v}).length
    },
    preventivoAtariffa () {
      if (this.selected && this.selected['voci'] && this.selected['voci'].length) return this.selected['voci'][0].tariffa_applicata.tariffa.nome == "A tariffa"
      else return false
    },
    withUser () {
      if (localStorage['utente_id']) return true
      else return false
    },
    showData() {
      if (this.withUser) return this.withUser
      else this.preventivoAtariffa
    }
  },
  methods: {
    vue_damn_linter: function(tr) {
        return [new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(tr.tariffa_applicata.scaglioni.find( s => {if (s.min_q <= tr.quantita && s.max_q >= tr.quantita) return s}).importo),' € (',new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(this.$tariffe.calcolaVoce(tr,0,this.selected['importo_vecchio'])),' €)'].join('')
    },
    commitStato() {
      let url = process.env.VUE_APP_BACKEND_API+'/preventivo/avanza_stato'
      axios.post(url, {id: this.selected['id'], id_stato: this.stati.find(e => e.ordine == this.avanza_stato).id},{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then(response => {
        this.popupStato = false
        this.$vs.notify({
          color: this.stati.find(e => e.id == response.data.id_stato).stato == 'Rifiutato' ? 'danger' : 'success',
          time: 4000,
          title: ['Preventivo N°',this.selected.numero].join(' '),
          text: ['Passato a',this.stati.find(e => e.id == response.data.id_stato).stato].join(' ')
        })
        this.$emit('stato-avanzato')
      })
    },
    getNumero(n,date) {
      let d_n = new Date(date).getYear() + 1900
      return [n,'/',d_n].join('')
    },
    closeSidebar(ev) {
      let elements = document.getElementsByClassName("vs-tooltip vs-tooltip-null")
      if (elements.length) {
        elements[0].remove();
      }
      this.$emit('close-me')
      ev.stopPropagation()
    },
    show_eachVoceDesc() {
      let ls = document.getElementsByClassName('quill')
      // console.log(ls);
      let incl = this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier != '0' && v.tariffa_applicata.quantifier != 'u') return v})
      let escl = this.selected['voci'].filter( v => { if (v.tariffa_applicata.quantifier == '0' || v.tariffa_applicata.quantifier == 'u') return v})
      for (let [key, value] of Object.entries(ls)) {
        // console.log(this.selected['voci'].length+' are '+incl.length+'-----'+escl.length)
        // value = ls[key] && key is idx number
        // console.log(key,ls[key])
        // console.log(key,'/',incl.length,' innerHTML: ',ls[key].innerHTML);
        if (key < incl.length) ls[key].innerHTML = incl.find( (el,idx) => idx == key).tariffa_applicata.descrizione
        // if (key < incl.length) ls[key].innerHTML = incl.find( (el,idx) => el.tariffa_applicata.id == key).tariffa_applicata.descrizione
        else if (escl && escl.length) ls[key].innerHTML = escl.find( (el,idx) => idx == key-incl.length).tariffa_applicata.descrizione
        // else if (escl && escl.length) ls[key].innerHTML = escl.find( (el,idx) => el.tariffa_applicata.id == key).tariffa_applicata.descrizione
        // incl.forEach( (v,idx) => {
        //     if (ls[key].id == 'quill-'+idx)
        //       ls[key].innerHTML = v.tariffa_applicata.descrizione;
        //   })
        // escl.forEach( (v,idx) => {
        //     if (ls[key].id == 'quill-'+(idx+incl.length))
        //       console.log(v.tariffa_applicata.descrizione+'-----')
        //       ls[key].innerHTML = v.tariffa_applicata.descrizione;
        //   })
      }
    },
    open_stato() {
      this.popupStato = true
    },
    generatePDF(ev) {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      let p_to_print = _.cloneDeep(this.selected)

      axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/generate_file', {
        templates: [{nuovo_nome: 'preventivo.docx'}],
        object: this.$tariffe.generatePDFpreventivo(p_to_print),
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
        responseType: 'blob'
      })
      .then(
        response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
        const link = document.createElement('a');
        link.href = url
        this.$vs.loading.close()
        link.setAttribute('download', response.headers['x-file-name']);
        document.body.appendChild(link);
        link.click();
      }
      ).catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
      ev.stopPropagation()
    },
    inviaDoc(ev) {
      this.$emit('email-me',this.selected.id)
      if (ev) {
        ev.stopPropagation()
      }
    },
    sortVoci() {
      function compare_n(a, b) {
        const position_a = a.tariffa_applicata.weight
        const name_a = a.tariffa_applicata.nome.toUpperCase()
        const position_b = b.tariffa_applicata.weight
        const name_b = b.tariffa_applicata.nome.toUpperCase()

        let comparison = 0;
        if (position_a > position_b) {
          comparison = 1;
        } else if (position_a < position_b) {
          comparison = -1;
        } else {
          if (name_a > name_b) comparison = 1
          else comparison = -1
        }
        return comparison;
      }
      this.selected['voci'].sort(compare_n)
      // this.voci.forEach( (v,i) => {
      //   console.log('Position: ',i,' weight: ',v.  tariffa_applicata.weight,' Nome: ',v.tariffa_applicata.nome);
      // });
    },
  },
  watch: {
    'selected.voci' () {
      this.show_eachVoceDesc()
      setTimeout(() => this.show_eachVoceDesc(),600)
    }
  },
}
</script>
